module.exports = __webpack_public_path__ + "img/pt-BR.c089cf9c.svg";